import React, { useEffect, useState } from 'react';
import axios from 'axios';
import configApi from '../../config';

const TotalReservations = () => {
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        axios.get(`${configApi.apiEndpoint}/api/Stats/TotalReservations`, config)
            .then(response => {
                setTotal(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the total reservations:', error);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div className="metric-card">
                <div className="skeleton-circle"></div>
                <div className="metric-data gap-2">
                    <div className="skeleton-box" style={{ width: '80px', height: '28px' }}></div>
                    <div className="skeleton-box" style={{ width: '120px', height: '14px' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="metric-card w-100">
            <div className="metric-icon">
                <i className="bi bi-calendar-check"></i>
            </div>
            <div className="metric-data">
                <h3>{total}</h3>
                <span>Všetky rezervácie</span>
            </div>
        </div>
    );
};

export default TotalReservations;
